import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import React, { useState } from 'react';
import { Col, Form, Collapse, Row } from 'antd';
import { ContentCollapse } from '../styles';
import { useDictionaryTranslation } from '../../../../hooks/useDictionaryTranslation';
import { CustomSwitch } from '../../../../components/customSwitch/CustomSwitch';
import { SelectServiceType } from '../../../../components/services/forms/SelectServiceType';

const TechnicianManagementOptions = ({ userData }) => {
  const { translate: t } = useDictionaryTranslation();
  const { Panel } = Collapse;
  const [enableExplicitServicesTypes, setEnableExplicitServicesTypes] = useState(userData?.profile.canCreateServices);
  const [disableAllServicesTypes, setDisableAllServicesTypes] = useState(userData?.profile?.useExplicitServiceTypes);
  const { accountModules } = useSelector((state) => ({
    accountModules: state.auth.accountModules,
  }));

  const onEnableExplicitServicesTypes = (value) => {
    setEnableExplicitServicesTypes(value);
  };

  const onEnableAllServicesTypes = (value) => {
    setDisableAllServicesTypes(!value);
  };

  return (
    <>
      <ContentCollapse>
        <Collapse className="collapse">
          <Panel header={t('displayOptions')}>
            <Col md={24}>
              <Row>
                {accountModules.finalCustomers ? (
                  <>
                    <Col xs={12}>
                      <Form.Item
                        name="canViewFinalCustomers"
                        label={t('canViewFinalCustomers')}
                        valuePropName="checked"
                      >
                        <CustomSwitch checkedText={t('yes')} unCheckedText={t('no')} />
                      </Form.Item>
                    </Col>
                    <Col xs={12} md={12}>
                      <Form.Item
                        name="canEditFinalCustomers"
                        label={t('canEditFinalCustomers')}
                        valuePropName="checked"
                      >
                        <CustomSwitch checkedText={t('yes')} unCheckedText={t('no')} />
                      </Form.Item>
                    </Col>
                  </>
                ) : null}
                <Col xs={12}>
                  <Form.Item name="canCreateIncidentNotes" label={t('canCreateIncidentNotes')} valuePropName="checked">
                    <CustomSwitch checkedText={t('yes')} unCheckedText={t('no')} />
                  </Form.Item>
                </Col>

                <Col xs={12}>
                  <Form.Item name="canCreateServices" label={t('canCreateServices')} valuePropName="checked">
                    <CustomSwitch
                      checked
                      checkedText={t('yes')}
                      unCheckedText={t('no')}
                      onChange={onEnableExplicitServicesTypes}
                    />
                  </Form.Item>
                </Col>
                {accountModules?.advancedAvailability ? (
                  <Col xs={12}>
                    <Form.Item
                      name="administrateAdvancedAvailability"
                      label={t('administrateAvailability')}
                      valuePropName="checked"
                    >
                      <CustomSwitch checked checkedText={t('yes')} unCheckedText={t('no')} />
                    </Form.Item>
                  </Col>
                ) : null}
                {enableExplicitServicesTypes ? (
                  <>
                    <Col xs={24}>
                      <Form.Item name="useAllServiceTypes" label={t('canCreateAllServices')} valuePropName="checked">
                        <CustomSwitch
                          checked
                          checkedText={t('yes')}
                          unCheckedText={t('no')}
                          onChange={onEnableAllServicesTypes}
                        />
                      </Form.Item>
                    </Col>

                    {disableAllServicesTypes ? (
                      <>
                        <Col xs={24}>
                          <Form.Item
                            name="explicitServiceTypes"
                            label={t('selectServiceType')}
                            valuePropName="selectedServiceType"
                          >
                            <SelectServiceType idHeadquarter={userData.idsHeadquarters} multiple />
                          </Form.Item>
                        </Col>
                      </>
                    ) : null}
                  </>
                ) : null}
              </Row>
            </Col>
          </Panel>
        </Collapse>
      </ContentCollapse>
    </>
  );
};

export default TechnicianManagementOptions;

TechnicianManagementOptions.propTypes = {
  userData: PropTypes.object,
};
